export const MESSAGES_LOADING = 'MESSAGES_LOADING';
export const SET_CONVERSATIONS = 'SET_CONVERSATIONS';
export const SET_THREAD = 'SET_THREAD';
export const ADD_MESSAGE = 'ADD_MESSAGE';
export const MESSAGES_ERROR = 'MESSAGES_ERROR';
